<template class="lefts">

  <div class="home" >

  </div>
</template>

<script>
export default {
  created() {
    this.$router.replace('/orders')
  }
}
</script>
